import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Paper } from "@mui/material";

const CustomPaper = (props) => {
  return (
    <Paper
      {...props}
      sx={{
        "& ul": {
          maxHeight: "300px",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "4px",
            "&:hover": {
              background: "#555",
            },
          },
          // For Firefox
          scrollbarWidth: "thin",
          scrollbarColor: "#888 #f1f1f1",
        },
      }}
    />
  );
};

export default function MuiAutoComplete({
  multiple = false,
  label,
  options,
  size,
  value,
  onChange,
  defaultValue,
  width,
  fontSize,
  id,
}) {
  return (
    <div style={{ width: "100%", fontSize: fontSize }}>
      <Autocomplete
        multiple={multiple}
        id={id}
        options={options}
        value={value}
        defaultValue={defaultValue}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        ListboxProps={{
          style: {
            maxHeight: "300px",
          },
        }}
        PaperComponent={CustomPaper}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            size={size}
            style={{
              backgroundColor: "white",
              width: width ? width : "auto",
              margin: 0,
            }}
            inputProps={{
              ...params.inputProps,
              style: { fontSize: fontSize, borderRadius: 0 },
            }}
            InputLabelProps={{
              style: { fontSize: fontSize },
            }}
            margin="normal"
          />
        )}
      />
    </div>
  );
}
